import styled from "styled-components";

export const UserMessage = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-bottom: 40px;
  .talk-bubble {
    display: inline-block;
    position: relative;
    background: #e5e7f2;
    border-radius: 30px 30px 5px 30px;
    padding: 27px 18px;
  }

  .tri-right.btm-right:after {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left: auto;
    right: 0px;
    bottom: -20px;
    border: 12px solid;
    border-color: #e5e7f2 #e5e7f2 transparent transparent;
  }

  .talktext {
    text-align: left;
  }
  .talktext p {
    /* remove webkit p margins */
    -webkit-margin-before: 0em;
    -webkit-margin-after: 0em;
  }
`;
